/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';
import AttendeePicker from 'ui/components/meetings/AttendeePicker.vue';

const __vue_script__ = {
    name: 'ResourcesFilter',

    components: {
        GenericDocExternalPicker,
        AttendeePicker
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        selectedLocations: {
            type: Array,
            default: () => []
        },

        selectedParticipants: {
            type: Array,
            default: () => []
        },

        selectedProspects: {
            type: Array,
            default: () => []
        }
    },

    data() {
        const people = this.selectedParticipants.map(p => ({ _id: p, fp_type: 'person' }));
        const prospects = this.selectedProspects.map(p => ({ _id: p, fp_type: 'prospect' }));

        return {
            open: false,
            locations: this.selectedLocations,
            participants: [...people, ...prospects],
            attendeePickerOptions: {
                multiple: true,
                hidePaxStatus: true,
            }
        };
    },

    methods: {
        update() {
            this.$emit('input', {
                locations: this.locations,
                participants: this.participants.filter(p => p.fp_type === 'person').map(p => p._id),
                prospects: this.participants.filter(p => p.fp_type === 'prospect').map(p => p._id)
            });
        },

        reset() {
            this.locations = [];
            this.participants = [];
            this.update();
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resources-filter",class:{ open: _vm.open }},[_c('header',{attrs:{"tabindex":"0"},on:{"click":function($event){_vm.open = true}}},[_c('h5',[_c('i',{staticClass:"ic-calendar-agenda"}),_vm._v(_vm._s(_vm.$t('meetings.calendar.filters.title')))]),(_vm.open)?_c('a',{staticClass:"close",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.open = false}}},[_c('i',{staticClass:"ic-x"})]):_c('i',{staticClass:"ic-chevron-down"})]),(_vm.open)?_c('section',{staticClass:"filters"},[_c('div',{staticClass:"locations"},[_c('generic-doc-external-picker',{attrs:{"fp-type":"meeting_location","emit-key":"_id","value-key":"ids","name":"locations","label":_vm.$t('meetings.calendar.filters.locations'),"event-id":_vm.event._id,"multiple":true,"sortable":false},on:{"input":_vm.update},model:{value:(_vm.locations),callback:function ($$v) {_vm.locations=$$v},expression:"locations"}})],1),_c('div',{staticClass:"participants"},[_c('attendee-picker',{attrs:{"fp-type":"person","name":"participants","label":_vm.$t('meetings.calendar.filters.users'),"event":_vm.event,"options":_vm.attendeePickerOptions},on:{"input":_vm.update},model:{value:(_vm.participants),callback:function ($$v) {_vm.participants=$$v},expression:"participants"}})],1)]):_vm._e(),_c('footer',[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.reset}},[_vm._v(_vm._s(_vm.$t('meetings.calendar.filters.clear')))])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ResourcesFilter.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__